import * as React from "react";
import { Translation } from "react-i18next";
import { ListWrapper, ListSection, List, ListTitle, ListItem, ListItemHighlight } from "../list/index";
const getOptionName = (option, isPrinting, isBumpScreen) => {
    if ((isPrinting || isBumpScreen) && option.print_name) {
        return option.print_name;
    }
    return option.display_name || option.name;
};
const getModifierName = (modifier, isPrinting, isBumpScreen) => {
    if ((isPrinting || isBumpScreen) && modifier.print_name) {
        return modifier.print_name;
    }
    return modifier.display_name || modifier.name;
};
export const DishOpenItemModifierList = (props) => {
    const { open_item_modifiers, renderDetails, isPrinting, isBumpScreen } = props;
    return (React.createElement(Translation, null, (t) => (React.createElement(ListWrapper, null, open_item_modifiers.map((modifier, index) => {
        const options = (modifier.options || []).filter((option) => (option.qty || 0) > 0);
        if (options.length > 0) {
            return (React.createElement(ListSection, { key: `${modifier.name}-${index}` },
                React.createElement(ListTitle, null, getModifierName(modifier, isPrinting, isBumpScreen)),
                React.createElement(List, null, options.map((option, optionIndex) => {
                    const qty = option.qty || 1;
                    const price = option.total_price ?? option.base_price;
                    if (renderDetails.option_prices && price) {
                        if (qty === 1) {
                            return (React.createElement(ListItem, { key: `${option.name}-${optionIndex}`, className: "r-list-item" },
                                getOptionName(option, isPrinting, isBumpScreen),
                                React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                                    "+",
                                    t("currency", { value: price }))));
                        }
                        return (React.createElement(ListItem, { key: `${option.name}-${optionIndex}`, className: "r-list-item" },
                            getOptionName(option, isPrinting, isBumpScreen),
                            React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                                "+",
                                t("currency", { value: price }),
                                " x ",
                                qty)));
                    }
                    if (qty === 1) {
                        return (React.createElement(ListItem, { key: `${option.name}-${optionIndex}`, className: "r-list-item" }, getOptionName(option, isPrinting, isBumpScreen)));
                    }
                    return (React.createElement(ListItem, { key: `${option.name}-${optionIndex}`, className: "r-list-item" },
                        getOptionName(option, isPrinting, isBumpScreen),
                        React.createElement(ListItemHighlight, { className: "list-item-highlight" },
                            " x ",
                            qty)));
                }))));
        }
        return (React.createElement(ListSection, { key: `${modifier.name}-${index}` },
            React.createElement(List, null,
                React.createElement(ListItem, { className: "r-list-item" },
                    modifier.quantity ? `${modifier.quantity} x ` : "",
                    getModifierName(modifier, isPrinting, isBumpScreen),
                    renderDetails.option_prices && modifier.total_price
                        ? ` ${t("currency", { value: modifier.total_price })}`
                        : ""))));
    })))));
};
//# sourceMappingURL=index.js.map